import createReducer from 'shared/utils/createReducer';
import { LOGOUT } from 'modules/auth/actions/logout';
import RequestStatuses from 'modules/common/constants/requestsStatuses';
import { CREATE_APPOINTMENT } from 'modules/appointmentsManagement/actions/_api/createAppointment';

const defaultState = {
  requestStatus: RequestStatuses.default,
  details: null,
};

export default createReducer(defaultState, {
  [CREATE_APPOINTMENT.pending]: state => ({
    ...state,
    requestStatus: RequestStatuses.pending,
  }),
  [CREATE_APPOINTMENT.success]: (state, { payload }) => ({
    requestStatus: RequestStatuses.success,
    details: payload,
  }),
  [LOGOUT.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
});
